import { h, Host } from "@stencil/core";
export class Badge {
    render() {
        return (h(Host, { key: 'df5a8e48eb01f213df97c139ab182676cd6cfb59', role: "status" }, h("slot", { key: '8cffa4440e44f5b65b3be30856d13c4afe72f789' })));
    }
    static get is() { return "ux-badge"; }
    static get encapsulation() { return "shadow"; }
    static get originalStyleUrls() {
        return {
            "$": ["badge.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["badge.css"]
        };
    }
}
//# sourceMappingURL=badge.js.map
